import { render } from "./NcAlert.vue?vue&type=template&id=7ea02855"
import script from "./NcAlert.vue?vue&type=script&lang=js"
export * from "./NcAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__